import { render } from "./GrayText.vue?vue&type=template&id=573b92f1&scoped=true&ts=true"
import script from "./GrayText.vue?vue&type=script&lang=ts"
export * from "./GrayText.vue?vue&type=script&lang=ts"

import "./GrayText.vue?vue&type=style&index=0&id=573b92f1&scoped=true&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573b92f1"]])

export default __exports__